import {
  CREATE_SUBSCRIPTION_PROMOTION,
  GET_SUBSCRIPTIONS_PROMOTIONS,
  GET_SUBSCRIPTION_PROMOTION,
  SET_ALL_SUBSCRIPTIONS_PROMOTIONS,
  UPDATE_SUBSCRIPTION_PROMOTION,
} from "../../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
};

const subscriptionPromotiontReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_SUBSCRIPTIONS_PROMOTIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_SUBSCRIPTIONS_PROMOTIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case CREATE_SUBSCRIPTION_PROMOTION:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_SUBSCRIPTION_PROMOTION:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_SUBSCRIPTION_PROMOTION:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default subscriptionPromotiontReducer;
